import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { BusinessEntitiesService } from './api/business-entities.service';
import { BusinessEntitiesActions } from './business-entities.actions';

export class BusinessEntitiesEffects {
  private readonly actions$ = inject(Actions);
  private readonly svc = inject(BusinessEntitiesService);

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusinessEntitiesActions.getBusinessEntities),
      switchMap(({ tenantUuid }) =>
        this.svc.getBusinessEntities(tenantUuid).pipe(
          map((businessEntities) => BusinessEntitiesActions.loadSuccess({ businessEntities })),
          catchError((error) => of(BusinessEntitiesActions.loadFailure({ error }))),
        ),
      ),
    ),
  );
}
